$(document).on("click", ".question_product,.faq_question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question').removeClass('active');
    jQuery('.question_product,.faq_question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", ".footer_menu p", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
    jQuery(this).next().next().slideToggle();
  } else {
    jQuery('.footer_menu p').removeClass('active');
    jQuery('.footer_menu p').next().slideUp();
    jQuery('.footer_menu p').next().next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
    jQuery(this).next().next().slideToggle();
  }
});




 $(document).on("click", ".custom_button", function (e) {
     var video = jQuery(this).parents('.video_wrapper_custom').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
     jQuery(this).addClass('active');
 }
 });







$(document).on("click", "a[href='#compare']", function (e) {
  e.preventDefault();
  document.querySelector('#compare').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='#reviews2']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews2').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#faq']", function (e) {
  e.preventDefault();
  document.querySelector('#faq').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.landing_page_product').scrollIntoView({
    behavior: 'smooth'
  })
});



jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$(window).on('scroll', function () {
  $('.custom_counter .icons_with_text_flex').each(function () {
    var $wrap = $(this);
    if ($wrap.hasClass('start_count')) return;

    if (isScrolledIntoView(this) === true) {
      $wrap.addClass('start_count');

      $wrap.find('.count_js').each(function () {
        var $num     = $(this);
        var target   = parseFloat($num.data('value')) || 0;
        // optional: force decimal places via data-decimals="2"
        var decimals = $num.data('decimals');

        if (decimals == null) {
          // infer from target (e.g., 12.34 -> 2)
          var s = String($num.data('value'));
          var i = s.indexOf('.');
          decimals = i >= 0 ? (s.length - i - 1) : 0;
        }

        $num.prop('Counter', 0).animate({ Counter: target }, {
          duration: 2000,
          easing: 'swing',
          step: function (now) {
            // keep old ceil behavior for integers, else fixed decimals
            if (decimals > 0) {
              $num.text(now.toFixed(decimals));
            } else {
              $num.text(Math.ceil(now));
            }
          }
        });
      });
    }
  });
});






$(document).on("click", ".tab_item_pdp", function (e) {
var data_tab = $(this).attr('data_tab');
$('.tab_item_pdp').removeClass('active');
$(this).addClass('active');
$('.tab_content_pdp').hide();
$('.tab_content_pdp[data_tab="'+data_tab+'"]').show();
});


$(document).on("click", '.product_slider_custom_slider_button a.custom_hk_button', function(e) {
 e.preventDefault(); 
var this_element =  jQuery(this);
this_element.addClass('loading_hk');
var id = jQuery(this).attr('variant_id');
jQuery.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: id
},
  dataType: 'json', 
 success: function (data) { 
location.href="/checkout";
 } 
 });
  });



$(document).on("click", '.ajax_add_cart', function(e) {
  e.preventDefault(); 

  var this_element = jQuery(this);
  this_element.addClass('loading_hk');
  var id = jQuery(this).attr('variant_id');

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: id
    },
    dataType: 'json',
    success: function (data) { 
      this_element.text('ADDED TO CART');
      this_element.removeClass('loading_hk');

      jQuery.ajax({
        type: 'GET',
        url: '/?sections=cart-drawer,cart-icon-bubble',
        dataType: 'json',
        success: function (sections) {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.renderContents({
              id: data.id,
              sections: sections
            });

            cartDrawer.classList.remove('is-empty');
          }
        }
      });
    } 
  });
});




$(document).on("click", ".tab_item", function (e) {
var data_tab = $(this).attr('data_tab');
$('.tab_item').removeClass('active');
$(this).addClass('active');
$('.tab_content').hide();
$('.tab_content[data_tab="'+data_tab+'"]').show();
});



// ===== knobs =====
var MIN_FONT = 12,  MAX_FONT = 129; // desktop defaults
var MIN_OP   = 1, MAX_OP = 1;
var FALLOFF  = 0.6, SMOOTH = 0.18, EPS = 0.002;
var HEADER   = 70;                   // fixed header height

var MOBILE_MQ = window.matchMedia('(max-width: 915px)');
function applyFontRange(){
  if (MOBILE_MQ.matches){ MIN_FONT = 7; MAX_FONT = 69; }
  else { MIN_FONT = 12; MAX_FONT = 129; }
}
applyFontRange();
MOBILE_MQ.addEventListener?.('change', () => { applyFontRange(); requestTick(); });

function clamp(v,a,b){ return Math.max(a, Math.min(b, v)); }
function lerp(a,b,t){ return a + (b - a) * t; }
function smoothstep(t){ return t*t*(3 - 2*t); }

let animating = false;
function update(){
  var vh = window.innerHeight;
  var vTop = HEADER, vBottom = vh, vH = vBottom - vTop;
  var vCenter = vTop + vH/2;

  var needsMore = false;

  document.querySelectorAll('.its_a_lot1 p').forEach(function(el){
    var rect = el.getBoundingClientRect();
    var elemCenter = rect.top + rect.height/2;

    // 0 at edges of the usable viewport, 1 at center
    var d = Math.abs(elemCenter - vCenter);
    var tRaw  = 1 - clamp(d / (vH * FALLOFF), 0, 1);
    var tEase = smoothstep(tRaw);

    // smooth toward target
    var s = el.__scrollFx || { cur: 0 };
    if (tEase > 1 - EPS) s.cur = 1;
    else if (tEase < EPS) s.cur = 0;
    else s.cur += (tEase - s.cur) * SMOOTH;

    if (Math.abs(s.cur - tEase) > EPS) needsMore = true;

    // apply real font-size (no transform)
    var targetFont = lerp(MIN_FONT, MAX_FONT, s.cur);
    el.style.fontSize = targetFont.toFixed(2) + 'px';

    // opacity (yours is fixed 1..1, but kept for completeness)
    var opacity = lerp(MIN_OP, MAX_OP, s.cur);
    el.style.opacity = (opacity > 0.999 ? 1 : opacity).toString();

    // active while inside usable viewport
    if (rect.bottom > vTop && rect.top < vBottom) el.classList.add('active');
    else el.classList.remove('active');

    el.__scrollFx = s;
  });

  if (needsMore) requestAnimationFrame(update);
  else animating = false;
}

function requestTick(){
  if (!animating){ animating = true; requestAnimationFrame(update); }
}

// run
window.addEventListener('scroll', requestTick, { passive: true });
window.addEventListener('resize', requestTick);
document.addEventListener('DOMContentLoaded', requestTick);
